import { toLines } from '../../../../common/utils'

const dishTypeSimpleDetailsFormInitialValues = ({
  description,
  synonyms,
  position,
  isExcludedFromSearch,
  isExcludedFromBrowsing,
}) => ({
  description,
  synonyms: toLines(synonyms),
  position,
  isExcludedFromSearch,
  isExcludedFromBrowsing,
})

export default dishTypeSimpleDetailsFormInitialValues
